import Vue from 'vue';
// import * as constants from '../constants';

// const nms = [ constants.NAMESPACE, 'store', 'mutations' ].join('/');
// const log = require('debug')('@mycure/vue-plugins/' + nms);

/// imports and local declarations
/**
 * @typedef {import('./state').default} State
 * @typedef {import('./state').PaginationOpts} PaginationOpts
 * @typedef {import('./state').ActivityLog} ActivityLog
 */

/**
 * @param {State} state
 * @param {Object} obj
 * @param {number} obj.total
 * @param {PaginationOpts} obj.paginationOpts
 * @param {ActivityLog[]} obj.items
 */
export function setActivityLogs (state, obj) {
  const { items, total, paginationOpts } = Object.assign({}, obj);
  state.logs = items || [];
  state.logsTotal = total || state.logs.length;
  state.logsPaginationOpts = paginationOpts || {};
}

/**
 * @param {State} state
 * @param {Object} obj
 * @param {boolean} [obj.upsert=true]
 * @param {ActivityLog[]} obj.items
 */
export function updateInActivityLogs (state, obj) {
  const { items, upsert } = obj;
  const list = state.logs;
  items.forEach(item => {
    // find existing
    const index = list.findIndex(i => i.id === item.id);

    // update existing (inherit patient details)
    if (~index) {
      item = { ...item };
      return Vue.set(list, index, item);
    }

    // add to list
    if (upsert) list.push(item);
  });
}
